import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import _ from "underscore";
import { gettext } from "web/script/modules/django-i18n";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import LeadLink from "web/react/components/lead-link/lead-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./price-info.css";


export function PriceInfo({
    currentPriceHtml,
    // note: formattedPrice is the previous price if eg on sale. the "real" price is currentPrice
    formattedPrice,
    isInStock,
    isOnSale,
    isSavedForLater,
    leadUrl,
    retailerName,
    selectedShipping,
}) {
    // If it's out of stock, it's not on sale
    if (!isInStock) {
        isOnSale = false;
    }

    const fromSpanProps = {
        class: styles.from,
    };
    // we escape retailerName, and so mark this string as available for dangerouslySetInnerHTML
    const fromRetailerLabelSafeHtml = {
        __html: gettext("in_stock_product.from_retailer.in_spans", {
            from_span_props: getHtmlProps(fromSpanProps),
            retailer_name_span_props: "",
            retailer_name: _.escape(retailerName),
        }),
    };

    let shippingCostLabel = "";
    let guaranteedFreeShipping = false;
    if (selectedShipping) {
        if (selectedShipping.is_free) {
            guaranteedFreeShipping = true;
            shippingCostLabel = gettext("general.free_shipping");
        } else {
            shippingCostLabel = gettext("in_stock_product.shipping_cost", {
                shipping_cost: selectedShipping.formatted_price,
            });
        }
    }

    return (
        <div className={styles.priceArea}>
            <span className={styles.bothPrices}>
                <span
                    className={classnames(styles.price, {
                        [styles.oos]: !isInStock,
                    })}
                    dangerouslySetInnerHTML={{ __html: currentPriceHtml }}
                />
                {isOnSale && (
                    <span className={styles.originalPrice}>
                        {" "}
                        <del>{formattedPrice}</del>
                    </span>
                )}
            </span>
            {shippingCostLabel && (
                <span
                    className={classnames(styles.shippingCost)}
                >
                    {guaranteedFreeShipping && <SVGIcon name="truck" className={styles.freeShippingIcon} />}
                    <span className={styles.shippingCostLabel}>{shippingCostLabel}</span>
                </span>
            )}
            <div className={styles.retailArea}>
                <LeadLink reason="retailer-link" href={leadUrl} isSavedForLater={isSavedForLater}>
                    <span
                        className={styles.retailer}
                        dangerouslySetInnerHTML={fromRetailerLabelSafeHtml}
                    />
                </LeadLink>
            </div>
        </div>
    );
}

PriceInfo.propTypes = {
    currentPriceHtml: PropTypes.string.isRequired,
    formattedPrice: PropTypes.string.isRequired,
    isInStock: PropTypes.bool,
    isOnSale: PropTypes.bool.isRequired,
    isSavedForLater: PropTypes.bool.isRequired,
    leadUrl: PropTypes.string.isRequired,
    retailerName: PropTypes.string.isRequired,
    selectedShipping: ShippingOptionPropType,
};

PriceInfo.defaultProps = {
    isInStock: true,
};

export default PriceInfo;
